import { createTheme } from '@mui/material/styles';

export const styledTheme = {
  primary: '#3d3d3d',
  fillColor: '#727272',
  borderColor: '#707070',
  bgColor: '#f6f6f6',
  dropBackground: 'rgba(61, 61, 61, 0.1)',
  goldColor: '#bea06e',
  errorColor: '#ab5243',
  inputError: '#dc3545',
  lightGray: '#f6f6f6',
  lighterGray: '#707070',
  modalBackground: 'rgba(43, 43, 43, 0.94)',
  transparent: 'transparent',
  textColor: '#4e4e4e',

  // eslint-disable-next-line quotes
  fontMontserrat: `'Montserrat', sans-serif`,
  border: '1px solid #707070',
  defaultSize: '15px',
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: '#80CCBF',
      light: '#dbf0ed',
      dark: '#29A88F',
    },
    secondary: {
      main: '#bea06e',
    },
  },
});
